import type { TrigKey } from './keys';

export const sw: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Hisabati · Trigonometri',
  'panel.experiment': 'Jaribio',
  'panel.params': 'Vipimo',
  'panel.scene': 'Chagua jaribio',
  'experiment.right-triangle.label': 'Pembe tatu mraba',
  'experiment.unit-circle.label': 'Mduara wa kitengo',
  'experiment.wave-studio.label': 'Studio ya mawimbi',
  'experiment.identity-playground.label': 'Misimu sawa',
  'experiment.triangle-solver.label': 'Mtatuzi wa pembetatu',
  'experiment.circular-polar.label': 'Mzunguko & polar',
  'hint.line1': 'Vuta nukta na sogeza vidhibiti.',
  'hint.line2': 'Maudhui ya elimu yapo katika jiometri, si maandishi.',
  'rt.angle.a': 'Pembe A',
  'rt.angle.b': 'Pembe B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radiani',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Funga 30°/45°/60°',
  'uc.units': 'Vipimo',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Onyesha ASTC',
  'uc.snap.common': 'Funga pembe za kawaida',
  'uc.angle.value': '∠',
  'uc.units.deg': 'digrii',
  'uc.units.rad': 'rad',
  'uc.units.both': 'digrii+rad',
  'ws.fn': 'Kazi',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Upeo',
  'ws.frequency': 'B — Marudio',
  'ws.phase': 'C — Mabadiliko ya awamu',
  'ws.shift': 'D — Mabadiliko wima',
  'ws.rform.toggle': 'Toleo la fomu-R',
  'ws.rform.a': 'a (kigezo sin)',
  'ws.rform.b': 'b (kigezo cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Anza upya',
  'ws.base': 'Onyesha mkondo wa msingi',
  'ip.id.pythagorean': 'Pythagorian',
  'ip.id.reciprocal': 'Kinyume',
  'ip.id.quotient': 'Mgawanyiko',
  'ip.id.sum': 'Jumla',
  'ip.id.difference': 'Tofauti',
  'ip.id.double': 'Pembe mara mbili',
  'ip.id.half': 'Nusu ya pembe',
  'ip.play': 'Cheza',
  'ip.pause': 'Simamisha',
  'ip.step': 'Hatua',
  'ip.reset': 'Anza upya',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'Itakuja v2 — uthibitisho huu unahitaji ujenzi wa kina zaidi.',
  'ts.area': 'Eneo',
  'ts.sineRule': 'Sheria ya sine',
  'ts.cosineRule': 'Sheria ya cosine',
  'ts.ambiguous.toggle': 'Onyesha pembetatu kivuli inapokuwa wazi',
  'ts.reset': 'Anza upya kwa sawa-pande',
  'ts.snap.integers': 'Funga kwa nambari kamili',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Pande',
  'ts.section.angles': 'Pembe',
  'ts.section.sineRule': 'Sheria ya sine',
  'ts.section.cosineRule': 'Sheria ya cosine',
  'ts.section.area': 'Eneo',
  'cp.omega': 'Kasi ya pembe',
  'cp.plot.y': 'Chora y (sin)',
  'cp.plot.x': 'Chora x (cos)',
  'cp.polar.label': 'Mchoro wa polar',
  'cp.polar.circle': 'Mduara (r = 1)',
  'cp.polar.rose': 'Waridi (r = sin 3θ)',
  'cp.polar.cardioid': 'Cardioid (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Kadirio la pembe ndogo (sin x ≈ x)',
  'cp.play': 'Cheza',
  'cp.pause': 'Simamisha',
  'cp.reset': 'Anza upya',
  'cp.step': 'Hatua π/12',
};
